export default function($el) {
    if ($el.animationInProgress) {
        if (window.requestAnimationFrame) {
            cancelAnimationFrame($el.animationRafId);
        } else {
            clearTimeout($el.animationTimeoutId);
        }

        $el.animationInProgress = false;
    }
}